import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Button } from '@lt/components';
import { i18n } from '@lt/localization';
import { pluralizeReviews } from 'src/utils/pluralizeUtils';
import { getIsMobile } from 'src/store/view/selectors';
import { getHasReviewsSection } from 'src/store/reviews/selectors';
import {
  scrollToReviewsAction,
  showPageAction,
} from '../../../store/actions/view';
import { HOTEL_MOBILE_PAGES } from '../../../constants';

import styles from './review.module.css';

interface ShowReviewsButtonProps {
  hasReviewsSection: boolean;
  onClickDesktop: () => void;
  onClickMobile: () => void;
  label: string;
  isMobile: boolean;
  className?: string;
  totalReviews?: number;
}

const ShowReviewsButton = React.memo(
  ({
    hasReviewsSection,
    onClickDesktop,
    onClickMobile,
    label,
    isMobile,
    className,
    totalReviews,
  }: ShowReviewsButtonProps) =>
    hasReviewsSection && (
      <Button
        size="none"
        className={classnames(styles.button, className, {
          [styles.buttonMobile]: isMobile,
        })}
        isMobile={isMobile}
        onClick={isMobile ? onClickMobile : onClickDesktop}
      >
        {totalReviews
          ? `${i18n.t('hotel.reviews.show')} ${totalReviews} ${pluralizeReviews(
              totalReviews,
            )}`
          : label}
      </Button>
    ),
);

const mapStateToProps = (state) => ({
  isMobile: getIsMobile(state),
  hasReviewsSection: getHasReviewsSection(state),
  label: i18n.t('hotel.reviews.moreReviews'),
});

const mapDispatchToProps = (dispatch) => ({
  onClickDesktop: () => dispatch(scrollToReviewsAction()),
  onClickMobile: () => dispatch(showPageAction(HOTEL_MOBILE_PAGES.REVIEWS)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowReviewsButton);
